import type {
  GetPermissionDetailsParams,
  OyResponse,
  PermissionProduct,
  UserPermission,
} from '@oy/types';
import axios, { AUTH_PREFIX } from 'src/clients/axios';

export const getPermissionDetails = (params?: GetPermissionDetailsParams) => {
  return axios.request<OyResponse<PermissionProduct[]>>({
    method: 'get',
    url: `${AUTH_PREFIX}/permission/details`,
    params,
  });
};

export const getUserPermission = () => {
  return axios.request<OyResponse<UserPermission[]>>({
    method: 'get',
    url: `${AUTH_PREFIX}/permission`,
    params: {
      product: 'BUSINESS_DASHBOARD',
    },
  });
};
